export default "__VITE_ASSET__CMjSrZ8w__"